<!-- Navigation services (panneau gauche) -->
<div class="w-[173px] shrink-0 flex flex-col gap-2 overflow-y-auto m-5 mr-0">
  @for (button of getAllButtons(); track button.id) {
  <button type="button" (click)="selectService(button.id)"
    class="flex items-center gap-2 p-2 rounded-[10px] transition-colors border"
    [class.bg-vert-3]="activeServiceId() === button.id" [class.border-vert-2]="activeServiceId() === button.id"
    [class.bg-gris-4]="activeServiceId() !== button.id" [class.border-gris-4]="activeServiceId() !== button.id">
    <!-- Icône : soit les 4 carrés colorés, soit image de service -->
    <div class="size-[40px] rounded-[5px] shrink-0 relative overflow-hidden" [style.background]="
          button.isAllButton ? 'rgb(229, 245, 252)' : (button.bgColor ?? '#f9f9f9')
        ">
      @if (button.isAllButton) {
      <div class="absolute top-[7px] left-[7px] size-[11px] rounded-[2px] bg-[#ffd700]"></div>
      <div class="absolute top-[7px] right-[7px] size-[11px] rounded-[2px] bg-[#fe004e]"></div>
      <div class="absolute bottom-[7px] left-[7px] size-[11px] rounded-[2px] bg-[#8abd27]"></div>
      <div class="absolute bottom-[7px] right-[7px] size-[11px] rounded-[2px] bg-[#0099dd]"></div>
      } @else if (button.imageUrl) {
      <img [src]="button.imageUrl" class="absolute inset-0 w-full h-full object-contain" alt="" />
      }
    </div>

    <!-- Texte du bouton -->
    <span class="flex-1 text-[13px] text-left leading-tight fg-noir-2 truncate min-w-0"
      [class.font-bold]="activeServiceId() === button.id">
      {{ button.isAllButton ? (button.name | translate) : button.name }}
    </span>

    <!-- Compteur -->
    <span
      class="text-[13px] font-semibold shrink-0 min-w-[24px] h-[24px] flex items-center justify-center rounded-full fg-gris-1"
      [class.fg-vert-1]="activeServiceId() === button.id" [class.bg-white]="activeServiceId() === button.id"
      [class.bg-gris-4]="activeServiceId() !== button.id">
      {{ button.coursesCount }}
    </span>
  </button>
  }
</div>

<!-- Zone centre : sélection des plats -->
<div class="flex-1 min-w-0 bg-gris-4 rounded-[10px] flex flex-col overflow-hidden m-5">
  <!-- Barre du haut : titre + recherche -->
  <div class="flex items-center h-[68px] px-5 gap-[10px] border-b border-gris-3 shrink-0 bg-gris-4 rounded-t-[10px]">
    <!-- Icône + titre : service sélectionné ou "Voir tout" -->
    @if (activeService(); as sc) {
    <div class="size-[40px] rounded-[5px] shrink-0 relative overflow-hidden"
      [style.background]="sc.bgColor ?? '#f9f9f9'">
      @if (sc.imageUrl) {
      <img [src]="sc.imageUrl" class="absolute inset-0 w-full h-full object-contain" alt="" />
      }
    </div>
    <span class="text-[20px] font-semibold fg-noir-2 shrink-0">
      {{ sc.part.service_name }}
    </span>
    } @else {
    <div class="size-[40px] rounded-[5px] bg-[#e5f5fc] relative shrink-0 overflow-hidden">
      <div class="absolute top-[7px] left-[7px] size-[11px] rounded-[2px] bg-[#ffd700]"></div>
      <div class="absolute top-[7px] right-[7px] size-[11px] rounded-[2px] bg-[#fe004e]"></div>
      <div class="absolute bottom-[7px] left-[7px] size-[11px] rounded-[2px] bg-[#8abd27]"></div>
      <div class="absolute bottom-[7px] right-[7px] size-[11px] rounded-[2px] bg-[#0099dd]"></div>
    </div>
    <span class="text-[20px] font-semibold fg-noir-2 shrink-0">
      {{ 'order.view_all' | translate }}
    </span>
    }
    <!-- Barre de recherche -->
    <label
      class="ml-auto flex items-center gap-[10px] h-[48px] px-[20px] rounded-[5px] w-[319px] shrink-0 border border-gris-3 bg-white cursor-text hover:border-gris-2 focus-within:border-bleu-1 transition-colors">
      <input type="text" class="flex-1 text-[16px] fg-noir-2 outline-none bg-transparent min-w-0 border-none"
        [value]="searchQuery()" (input)="searchQuery.set($any($event.target).value)"
        [placeholder]="'order.search_placeholder' | translate" />
      <app-svg class="fg-gris-2 shrink-0" height="20" svgPath="assets/svg/search.svg" width="20" />
    </label>
  </div>

  <!-- Sections de services avec leurs plats -->
  <div id="service-top" class="flex-1 overflow-y-auto p-5 flex flex-col gap-[30px]">
    @for (sc of filteredServiceCourses(); track sc.part.service_id; let i = $index) {
    <div [id]="'service-' + sc.part.service_id" class="flex flex-col gap-[10px]">
      <!-- Label de section -->
      <p class="text-[14px] leading-none">
        <span class="font-semibold fg-noir-2">{{ sc.part.service_name }}</span>
        @if (sc.part.is_mandatory && !isFullMenu()) {
        <span class="fg-gris-1">
          {{ ' (' + sc.part.quantity + ' ' }}{{ 'order.required_choice' | translate }}{{ ')' }}
        </span>
        }
      </p>

      <!-- Grille des cartes plat -->
      <div class="flex flex-wrap gap-[10px]">
        @if (sc.isLoading) {
        <div class="flex items-center justify-center h-[178px] w-full">
          <span class="text-[14px] fg-gris-1">{{ 'common.loading' | translate }}</span>
        </div>
        } @else if (sc.courses.length === 0) {
        <div class="flex items-center justify-center h-[178px] w-full">
          <span class="text-[14px] fg-gris-1">{{ 'order.no_courses' | translate }}</span>
        </div>
        } @else {
        @for (course of sc.courses; track course.id) {
        <app-course-card [course]="course" [quantity]="getQuantity(course.id)"
          [showPrice]="sc.part.service_is_not_in_admission"
          [disabled]="isFullMenu() || isServiceFull(sc.part, sc.courses)" [readOnly]="isFullMenu()"
          [bgColor]="sc.bgColor ?? null" [imageUrl]="sc.imageUrl ?? null" (increment)="increment(course.id)"
          (decrement)="decrement(course.id)" />
        }
        }
      </div>
    </div>
    }
  </div>
</div>

<!-- Zone droite : récapitulatif -->
<div class="w-[342px] shrink-0 bg-gris-4 rounded-[10px] flex flex-col overflow-hidden m-5 ml-0">
  <!-- Titre -->
  <p class="text-[20px] font-semibold text-[#383737] px-5 pt-5 pb-3 shrink-0 leading-none">
    {{ 'order.summary_title' | translate }}
  </p>

  <!-- Liste des plats sélectionnés -->
  <div class="flex-1 overflow-y-auto px-5 flex flex-col gap-3 min-h-0">
    @for (item of selectedItems(); track item.serviceIndex + '-' + item.course.id) {
    <app-summary-course-card [course]="item.course" [serviceName]="item.part.service_name"
      [showPrice]="item.part.service_is_not_in_admission" [disabled]="isFullMenu()"
      [quantity]="getQuantity(item.course.id)" [bgColor]="item.bgColor" [imageUrl]="item.imageUrl"
      (remove)="decrement(item.course.id)" />
    }

    @if (selectedItems().length === 0) {
    <div class="flex items-center justify-center py-5">
      <span class="text-[14px] fg-gris-1">{{ 'order.summary_empty' | translate }}</span>
    </div>
    }
  </div>

  @if (formulaPrice() > 0 || supplementTotal() > 0) {
  <!-- Séparateur -->
  <div class="h-px bg-gris-3 mx-5 shrink-0 mt-3"></div>
  }

  <!-- Détail des prix -->
  <div class="px-5 py-3 flex flex-col gap-[6px] shrink-0">
    @if (formulaPrice() > 0) {
    <div class="flex items-center justify-between">
      <span class="text-[16px] text-[#494949]">{{ 'order.formula_label' | translate }}</span>
      <span class="text-[14px] font-semibold fg-gris-1">{{ formulaPrice() | formatPrice }}</span>
    </div>
    }
    @if (supplementTotal() > 0) {
    <div class="flex items-center justify-between">
      <span class="text-[16px] text-[#494949]">
        {{ 'order.supplement_label' | translate }}
      </span>
      <span class="text-[14px] font-semibold fg-gris-1">{{
        supplementTotal() | formatPrice
        }}</span>
    </div>
    }
  </div>

  <!-- Total -->
  <div class="px-5 pb-3 shrink-0">
    <div class="flex items-center justify-between border-t border-gris-3 pt-3">
      <span class="text-[20px] font-semibold text-[#3c3b3b]">
        {{ 'order.total_label' | translate }}
      </span>
      <span class="text-[20px] font-semibold fg-gris-1">{{ totalPrice() | formatPrice }}</span>
    </div>
  </div>

  <!-- Bouton valider -->
  <div class="px-5 pb-5 shrink-0">
    <button type="button" (click)="validate()"
      class="w-full h-[64px] bg-vert-1 rounded-[5px] text-white text-[16px] font-semibold cursor-pointer hover:brightness-95 transition-all"
      [disabled]="!canValidate()" [class.bg-vert-1]="canValidate()" [class.cursor-pointer]="canValidate()"
      [class.bg-gris-3]="!canValidate()" [class.cursor-not-allowed]="!canValidate()">
      {{ 'order.validate_button' | translate }}
    </button>
  </div>
</div>